import { render, staticRenderFns } from "./AboutCollaborationsIntro.vue?vue&type=template&id=79ab196b&"
import script from "./AboutCollaborationsIntro.vue?vue&type=script&lang=js&"
export * from "./AboutCollaborationsIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports